import { BackButton } from '../../components/BackButton';
import { JourneyPicker } from '../JourneyPicker';
import { Row } from './SearchActionBar.styles';
import type { SearchActionBarProps } from './SearchActionBar.types';

const NOOP_SEARCH = () => undefined;

export function SearchActionBar({
  onBack,
  backAriaLabel,
  checkIn,
  checkOut,
  singleDateMode,
  adults,
  childCount,
  onRangeSelect,
  onAdultsChange,
  onChildrenChange,
  onEditSection,
  activeStep,
  labels,
}: SearchActionBarProps) {
  return (
    <Row data-active-step={activeStep}>
      <BackButton variant="contained" onClick={onBack} ariaLabel={backAriaLabel ?? 'Go back'} />
      <JourneyPicker
        mode="condensed"
        disableCategorySelect
        dateMode={singleDateMode ? 'single' : 'range'}
        showGuests
        controlled={{
          fromDate: checkIn ?? '',
          toDate: checkOut ?? '',
          adults,
          children: childCount,
          onRangeSelect,
          onAdultsChange,
          onChildrenChange,
        }}
        onSearch={NOOP_SEARCH}
        onEditSection={onEditSection}
        labels={labels}
      />
    </Row>
  );
}
